import React from 'react';
import moment from 'moment';
import session from 'services/sessionService';
import events from 'lib/events';
import forecastApi from 'api/forecast';
import {FormattedMessage} from 'react-intl';

// Row object
class Forecast extends React.Component {
  state = {
    user: null,
    cantload: false,
    cantfind: false,
    cantretrieve: false,
    zip: null,
    forecast: null,
    toggled: false,
  };

  componentDidMount() {
    this.setState({user: session.getUser()});
    if (session.getUser()) {
      this.getForecast(session.getUser());
    }
    this._userset = events.subscribe('userset', this.userDidChange);
  }

  componentWillUnmount() {
    this._userset.remove();
  }

  getForecast = (usr) => {
    if (!(usr && usr.zip && usr.zip !== this.state.zip)) {
      this.setState({cantload: true});
      return;
    }

    this.setState({
      zip: usr.zip,
    });

    forecastApi.getForecast(usr.zip)
      .then(forecast => {
        if (forecast.code === 400) {
          this.setState({cantfind: true});
          return;
        }

        this.setState({
          zip: usr.zip,
          forecast,
        });
      }, (rejectedResponse) => {
        if (rejectedResponse && !rejectedResponse.success && rejectedResponse.code === 8001) {
          this.setState({cantfind: true});
          return;
        }

        this.setState({cantretrieve: true});
      });
  };

  _userset = null;

  toggleList = () => {
    this.setState({
      toggled: !this.state.toggled,
    });
  };

  userDidChange = (data) => {
    this.setState({user: data});
    this.getForecast(data);
  };

  render() {
    if (this.state.forecast && this.state.forecast.daily) {
      const unit = this.state.forecast.flags && this.state.forecast.flags.units === 'ca' ? 'C' : 'F';

      let daily = this.state.forecast.daily.data.map((data, idx) => {
        return (
          <div key={idx} onClick={this.toggleList} className={'days ' + (this.state.toggled ? 'show-forcast' : 'hide-forcast')}>
            <h6>{moment(data.time * 1000).format('ddd')}</h6>
            <img src={'/Content/img/weather/' + data.icon + '.svg'} alt={data.summary} title={data.summary} />
            <div>
              <div>{Math.round(data.temperatureMax)}&deg;{unit}</div>
              <div>{Math.round(data.temperatureMin)}&deg;{unit}</div>
            </div>
            <i className={'bl bl-dropdown ' + (this.state.toggled ? 'spin-chev' : '')}/>
          </div>
        );
      });

      return (
        <div id='forecast'>
          { daily }
        </div>
      );
    }

    if (this.state.zip || this.state.cantload) {
      return (
        <div id='forecast'>
          <FormattedMessage id="navbar.forecast.loading.error" />
        </div>
      );
    }

    if(this.state.cantfind) {
      return (
        <div id='forecast'>
          <FormattedMessage id="navbar.forecast.zipcode.error" />
        </div>
      );
    }
    if(this.state.cantretrieve) {
      return (
        <div id='forecast'>
          <FormattedMessage id="navbar.forecast.retrieve.error" />
        </div>
      );
    }
    return (
      <div id='forecast'>
        <FormattedMessage id="navbar.forecast.loading" />
      </div>
    );
  }
}

export default Forecast;
